import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HealthReportdata } from "../schema/health-report.schema";
import { addHealthReport } from "../api/health-report.api";
import { healthKeys } from "./useHealthReports";
import { toast } from "react-toastify";
import axios from "axios";

export const useAddHealthReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      data,
      customerId,
      memberId,
    }: {
      data: HealthReportdata;
      customerId: number;
      memberId: number;
    }) => addHealthReport(data, customerId, memberId),

    onSuccess: (_, { memberId }) => {
      queryClient.invalidateQueries({ queryKey: healthKeys.list(memberId) });

      toast.success("Health Report Added!");
    },

    onError: (error) => {
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        toast.error(error?.response.data.message || "Something went wrong!");
      } else {
        toast.error("Failed to submit health report");
      }
    },
  });
};
